import React from 'react';
import { IconPropTypes } from 'ggApp/types/propTypes';

const YourTechFilledIcon = ({ color, size, className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M14.0697 2.55298L19.8649 4.1058C21.4653 4.53463 22.415 6.17964 21.9862 7.78004L19.1391 18.4053C18.7103 20.0057 17.0653 20.9555 15.4649 20.5267L9.66985 18.9741C8.06934 18.5453 7.11952 16.9001 7.54838 15.2996L10.3954 4.6743C10.8242 3.0739 12.4693 2.12415 14.0697 2.55298Z"
            fill={color}
        />
        <path
            d="M6 5.00113H8.23751L5.61667 14.7822C4.90196 17.4496 6.48488 20.1913 9.15221 20.906L12.8181 21.8882C12.558 21.9619 12.2834 22.0013 11.9996 22.0013H6C4.34315 22.0013 3 20.6581 3 19.0013V8.00113C3 6.34428 4.34315 5.00113 6 5.00113Z"
            fill={color}
        />
    </svg>
);

YourTechFilledIcon.propTypes = {
    ...IconPropTypes,
};

YourTechFilledIcon.defaultProps = {
    className: '',
    color: '#333333',
    size: '24px',
};

export default YourTechFilledIcon;
